export class AppConfig {
    linksBaseURL?: string;
    contentPath?: string;
    contentXML?: string;

    static mergeWithDefaultConfig(appConfig:AppConfig):AppConfig {
        return {
            linksBaseURL:(appConfig.linksBaseURL)?appConfig.linksBaseURL:DefaultAppConfig.linksBaseURL,
            contentPath:(appConfig.contentPath)?appConfig.contentPath:DefaultAppConfig.contentPath,
            contentXML:(appConfig.contentXML)?appConfig.contentXML:DefaultAppConfig.contentXML,
        }
    }
}

export const DefaultAppConfig = {
    linksBaseURL: "/",
    contentPath: "./data/",
    contentXML: "content_de.xml",
}